import { toggleEnforcePermissionChecks } from './beta/toggle-enforce-permission-checks.tsx';
import { load } from './load/index.tsx';

export const actions = {
	load,
	// beta actions
	toggleEnforcePermissionChecks,
};
